import React, { useState, useEffect } from "react";
import api from "../api/api";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";

import { Button, ButtonGroup, Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import { getCropEndDate } from "../utils/cropDates";

const CropList = ({ cropsList, Fields, Zones, refreshCrops }) => {
  const { t } = useTranslation();
  const [localCrops, setLocalCrops] = useState(cropsList || []);
  const [msgServer, setMsg] = useState("");
  const [classMsg, setCmsg] = useState("");
  const [displayMsg, setDispMsg] = useState("hide");
  const [iconMsg, setIconMsg] = useState("info");

  const navigate = useNavigate();

  useEffect(() => {
    setLocalCrops(cropsList);
  }, [cropsList]);

  useEffect(() => {
    setLocalCrops(cropsList);
  }, [cropsList]);

  const handleDelete = async (cropUid) => {
    let data = {
      crop_uid: cropUid,
    };
    await api
      .delete("/crop/delete-crop", { data: data })
      .then((response) => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: `${t("cannot_delete")}`,
            icon: "warning",
          });
        }
        if (response.data.type == "success") {
          setLocalCrops((prev) => prev.filter((crop) => crop.Uid !== cropUid));
          setMsg(`${t("delete_success")}`);
          setCmsg("success");
          setDispMsg("show");
          setIconMsg("check");
          hideMsg();
        }
      })
      .catch((error) => {
        swal({
          title: `${t("cannot_delete_crop")}`,
          icon: "error",
          text: t("Error"),
        });
      });
  };
  const hideMsg = () => {
    setTimeout(() => {
      setDispMsg("hide");
    }, 3000);
  };
  const [deletedCrops, setDeletedCrops] = useState([]);
  const [showDeletedModal, setShowDeletedModal] = useState(false);

  const fetchDeletedCrops = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const res = await api.get(`/crop/deleted-crops?userId=${user.id}`);
      setDeletedCrops(res.data.deletedCrops || []);
    } catch (err) {
      console.error("Failed to fetch deleted crops", err);
    }
  };

  // 🔹 Restore crop
  const handleRestoreCrop = async (crop_uid) => {
    try {
      const res = await api.post("/crop/restore-crop", { crop_uid });
      if (res.data.type === "success") {
        swal({ title: t("crop_restored_success"), icon: "success" });
        fetchDeletedCrops();
        await refreshCrops(); // 👈 pulls fresh list from backend
      } else {
        swal({ title: t("restore_failed"), icon: "error" });
      }
    } catch (err) {
      swal({ title: t("restore_error"), icon: "error" });
    }
  };

  const confirmDelete = (cropUid) => {
    swal({
      title: `${t("are_you_sure")}`,
      text: `${t("confirm_delete")}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (Delete) => {
        if (Delete) {
          await handleDelete(cropUid);
        }
      })
      .catch((error) => {
        swal({
          title: `${t("cannot_delete_crop")}`,
          icon: "error",
          text: t("Error"),
        });
      });
  };

  return (
    <>
      {displayMsg === "show" && (
        <div className={`mb-3 alert alert-${classMsg} fade show`}>
          <i className={`fa fa-${iconMsg} mx-2`}></i> {t(msgServer)}
        </div>
      )}

      {/* 🔹 Deleted Crops Button */}
      <div className="mb-3">
        <Button
          variant="secondary"
          onClick={() => {
            setShowDeletedModal(true);
            fetchDeletedCrops();
          }}
        >
          <i className="fa fa-trash-restore mx-2"></i>
          {t("deleted_crops")}
          {deletedCrops.length > 0 && (
            <span className="badge bg-danger ms-2">{deletedCrops.length}</span>
          )}
        </Button>
      </div>

      {/* 🔹 Deleted Crops Modal */}
      <Modal
        size="lg"
        show={showDeletedModal}
        onHide={() => setShowDeletedModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("deleted_crops")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deletedCrops.length === 0 ? (
            <div className="text-center py-4">
              <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
              <p className="text-muted">{t("no_deleted_crops")}</p>
            </div>
          ) : (
            <table className="table text-center table-bordered">
              <thead className="bg-light">
                <tr>
                  <th>{t("crop_type")}</th>
                  <th>{t("field")}</th>
                  <th>{t("zone")}</th>
                  <th>{t("deleted_at")}</th>
                  <th>{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {deletedCrops.map((crop) => {
                  const cropName = crop.crop_name || t("unknown_crop");
                  const fieldName = crop.field_deleted
                    ? t("deleted_field")
                    : crop.field_name || "-";
                  const zoneName = crop.zone_deleted
                    ? t("deleted_zone")
                    : crop.zone_name || "-";

                  return (
                    <tr key={crop.uid}>
                      <td>{cropName}</td>
                      <td>{fieldName}</td>
                      <td>{zoneName}</td>
                      <td>
                        {crop.deleted_at
                          ? new Date(crop.deleted_at).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td>
                        <ButtonGroup size="sm">
                          <Button
                            variant="success"
                            onClick={() => handleRestoreCrop(crop.uid)}
                            disabled={crop.field_deleted || crop.zone_deleted} // 🔹 block restore if parent missing
                          >
                            <i className="fa fa-undo"></i> {t("restore")}
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeletedModal(false)}
          >
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <div style={{ overflowX: "auto" }}>
        <table className="table mb-4 text-center table-bordered tabel-responsive-lg">
          <thead className="bg-light">
            <tr>
              <th scope="col" className="border-0">
                {t("crop_type")}
              </th>
              <th scope="col" className="border-0">
                {t("name_field")}
              </th>
              <th scope="col" className="border-0">
                {t("name_zone")}
              </th>
              <th scope="col" className="border-0">
                {t("Start season")}
              </th>
              <th scope="col" className="border-0">
                {t("End season")}
              </th>
              <th scope="col" className="border-0"></th>
            </tr>
          </thead>
          <tbody>
            {localCrops.map((item, indx) => {
              // Parse dates
              const startDate = new Date(item.growingDate);
              // Prefer the duration saved on this crop. The crop type contains
              // only the default duration and can differ after customization.
              const endDate = getCropEndDate(item);

              // Format function
              const formatDate = (d) => {
                if (!d) return ""; // no date
                const date = new Date(d);
                if (isNaN(date)) return ""; // invalid date
                return date.toISOString().split("T")[0];
              };
              let croptype = item.croptype;
              let nameField = "";
              let nameZone = "";
              let nameCrop = "";
              Fields.map((fieldData) => {
                if (fieldData.Id == item.field_id) {
                  nameField = fieldData.title;
                }
              });
              if (croptype) {
                nameCrop = croptype.crop;
              }
              Zones.map((zoneData) => {
                if (zoneData.Id == item.zone_id) {
                  nameZone = zoneData.name;
                }
              });
              return (
                <tr>
                  <td>{nameCrop}</td>
                  <td>{nameField}</td>
                  <td>{nameZone}</td>
                  <td>{formatDate(startDate)}</td>
                  <td>{formatDate(endDate)}</td>

                  <td>
                    <ButtonGroup size="sm" className="mr-2 gap-2">
                      <Button
                        onClick={() => navigate(`/crop/${item.Uid}`)}
                       
                        variant="info"
                      >
                        <i className="fas fa-pen" aria-hidden="true" />
                      </Button>
                      <Button
                        onClick={() => confirmDelete(item.Uid)}
                       
                        variant="danger"
                      >
                        <i className="fas fa-trash" aria-hidden="true" />
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CropList;
